export default "__VITE_ASSET__ME1F$mAN__"